export interface Volume {
  code: string
  name: string
  count: string
  /** Spine color from the product mockup. */
  color: string
  intro: string
  highlights: string[]
  note?: string
  result: string
}

const PRACTICES_NOTE = 'Includes 12 complete 60-minute practices.'

export const volumes: Volume[] = [
  {
    code: '1',
    name: 'The Youth Coaching Foundation',
    count: '12 practices',
    color: '#3b82f6',
    intro: 'Build the coaching structure needed to run clear, active and age-appropriate practices.',
    highlights: [
      'Athletic ready position',
      'First dribble',
      'Chest pass',
      'No-lines practice design',
      'How to organize 8, 12 or 16 players',
      'How to coach with one basket',
      'How to coach with limited basketballs',
      'Mixed-level adaptations',
      '1v1',
      '2v2',
      '3v3',
      'Practice planning',
      'Coaching cues',
      'Quick corrections',
      'Practice troubleshooting',
    ],
    note: PRACTICES_NOTE,
    result:
      'A clear visual foundation that helps you organize, explain, adapt and run youth basketball practices with confidence.',
  },
  {
    code: '2',
    name: 'Ball Handling & Passing',
    count: '12 practices',
    color: '#22c55e',
    intro: 'Teach players to control the ball, use both hands, pass accurately and move after the pass.',
    highlights: [
      'Ball familiarity',
      'Stationary dribbling',
      'Moving dribble',
      'Change of speed',
      'Change of direction',
      'Weak-hand development',
      'Ball protection',
      'Chest pass',
      'Bounce pass',
      'Receiving',
      'Passing on the move',
      'Pass + cut',
      'Partner work',
      'Decision passing',
      'Progression games',
    ],
    note: PRACTICES_NOTE,
    result:
      'Players become more confident with the ball and learn to connect dribbling, passing and movement.',
  },
  {
    code: '3',
    name: 'Shooting & Finishing',
    count: '12 practices',
    color: '#f97316',
    intro: 'Teach young players how to approach the basket, shoot with balance and finish under control.',
    highlights: [
      'Shooting stance',
      'Balance',
      'Footwork',
      'Close-range shooting',
      'Catch-and-shoot basics',
      'Layup footwork',
      'Right-hand layup',
      'Left-hand layup',
      'Finishing angles',
      'Jump stops',
      'Pivot + finish',
      'Game-like finishing',
      'Shooting games',
      'Progressions by age',
    ],
    note: PRACTICES_NOTE,
    result:
      'Players develop a clearer scoring foundation without overcomplicated mechanics.',
  },
  {
    code: '4',
    name: 'Defense, Movement & Rebounding',
    count: '12 practices',
    color: '#ef4444',
    intro: 'Build better movers before building better defenders.',
    highlights: [
      'Athletic movement',
      'Balance',
      'Coordination',
      'Acceleration',
      'Stopping',
      'Pivoting',
      'Lateral movement',
      'Reaction',
      'Defensive stance',
      'Defensive slides',
      'Staying between player and basket',
      '1v1 defense',
      'Rebounding basics',
      'Box-out introduction',
      'Outlet habits',
      'Defensive games',
    ],
    note: PRACTICES_NOTE,
    result:
      'Players improve movement quality, defensive awareness and basic rebounding habits.',
  },
  {
    code: '5',
    name: 'Small-Sided Games & Basketball IQ',
    count: '12 practices',
    color: '#8b5cf6',
    intro: 'Teach players to read the game — not just repeat drills.',
    highlights: [
      '1v1 decisions',
      '2v1 advantage games',
      '2v2 spacing',
      'Pass + cut',
      'Give-and-go',
      'Drive or pass',
      '3v3 spacing',
      'Finding open space',
      'Transition decisions',
      'Help concepts',
      'Scoring constraints',
      'Random starts',
      'Reaction games',
      'Read-and-react situations',
    ],
    note: PRACTICES_NOTE,
    result:
      'Players begin to make better decisions under pressure and understand how individual skills connect to real basketball.',
  },
  {
    code: '6',
    name: 'Team Play & Season Development',
    count: '12 practices',
    color: '#94a3b8',
    intro: 'Connect individual skills to team basketball and organize development across the season.',
    highlights: [
      'Spacing',
      'Pass and move',
      'Cutting',
      'Fill empty space',
      'Transition lanes',
      'Simple team offense',
      'Basic team defense',
      'Communication',
      'Game preparation',
      'Practice priorities',
      'Weekly planning',
      'Development checkpoints',
      '12-week roadmap',
      'Season organization',
    ],
    note: PRACTICES_NOTE,
    result:
      'A repeatable structure that helps you move from isolated skills to better team play.',
  },
]
